import { Box, Container, Grid, Typography, useTheme } from "@mui/material";
import React from "react";
import { resultsContent } from "../../data/resultsContent";
import StatCard from "../common/StatCard";
import SectionYellowTitle from "../common/SectionYellowTitle";
import SectionMainTitle from "../common/SectionMainTitle";
import useResponsiveSpacingGrid from "../../hooks/useResponsiveSpacingGrid";

const ResultsSection: React.FC = () => {
  const theme = useTheme();
  const spacing = useResponsiveSpacingGrid();

  return (
    <Box
      component="section"
      sx={{
        mt: 6,
        pb: 8,
        backgroundColor: theme.palette.background.default,
        mb: { xs: 2, md: 4, lg: 4 },
      }}
    >
      {/* Sección amarillo pequeño */}

      <Container maxWidth="lg">
        <SectionYellowTitle title={resultsContent.subtitle1} />
        <SectionMainTitle title={resultsContent.title} align="left" />

        <Typography
          variant="body1"
          align="justify"
          color="text.secondary"
          sx={{ mb: 6 }}
        >
          {resultsContent.subtitle}
        </Typography>
        <Grid container spacing={spacing}>
          {resultsContent.stats.map((stat, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <StatCard value={stat.value} label={stat.label} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ResultsSection;
